import React, { HTMLAttributes } from 'react';

export interface PageTitleProps extends HTMLAttributes<HTMLDivElement> {
}
export function PageTitle({className,...props}: PageTitleProps) {
    return <div className={`gwp-page-title ${className!==undefined?className:''}`} {...props}>{props.children}</div>;
}